import * as React from "react";
import { PureComponent } from "react";
import { Polyline } from "react-leaflet";
import config from "../App/config";

class MapRoutes extends PureComponent<any> {
  render() {
    const { routes, airports } = this.props;
    return routes.map((route: any) => {
      const positions = airports
        .filter(
          (airport: any) => airport.id === route.dep || airport.id === route.arr
        )
        .map((airport: any) => [airport.lat, airport.lon]);
      return (
        <Polyline
          key={route.dep + "-" + route.arr}
          positions={positions}
          color={config.polyline.color}
          weight={config.polyline.weight}
          smoothFactor={100}
        />
      );
    });
  }
}

export default MapRoutes;
